import React from 'react';
import styles from './IntroSection.module.css';

import Fade from 'react-reveal/Fade';

import downArrow from '../../images/down.svg';

const IntroSection = props => (
  <section className={styles.IntroSection}>
    <h1><Fade bottom cascade>{props.heading}</Fade></h1>
    <Fade delay={1000}>
    <p className={styles.description} style={{
      backgroundImage: `url(${props.textImg})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent',
      fontSize: `${props.fontSize ? props.fontSize : '70px'}`
    }}>{props.description}</p>
    </Fade>
    <img src={downArrow} alt="down" />
  </section>
)

export default IntroSection;